import { render, staticRenderFns } from "./Businesses.vue?vue&type=template&id=0d4e9623&scoped=true"
import script from "./Businesses.vue?vue&type=script&lang=js"
export * from "./Businesses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../Library/WebServer/Documents/LSA-New-V2/frontend-diy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4e9623",
  null
  
)

export default component.exports